// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class ServiceAccessByUserResource extends Resource {
    basePath: string = 'services/accessByUser/';

    objectPath: string = 'services/accessByUser/{ident}/';
}
